import { lazy, Suspense } from "react";
import type { ReactNode } from "react";
import { createBrowserRouter } from "react-router-dom";
import { AdminLayout } from "./layouts/admin-layout";
import { PublicLayout } from "./layouts/public-layout";

const AdminDashboard = lazy(() =>
  import("./pages/admin/admin-dashboard").then((module) => ({ default: module.AdminDashboard })),
);
const AdminMembersPage = lazy(() =>
  import("./pages/admin/admin-members-page").then((module) => ({ default: module.AdminMembersPage })),
);
const MemberEditorPage = lazy(() =>
  import("./pages/admin/member-editor-page").then((module) => ({ default: module.MemberEditorPage })),
);
const HomePage = lazy(() => import("./pages/public/home-page").then((module) => ({ default: module.HomePage })));
const MemberDetailPage = lazy(() =>
  import("./pages/public/member-detail-page").then((module) => ({ default: module.MemberDetailPage })),
);

function withSuspense(element: ReactNode) {
  return <Suspense fallback={<div className="page-shell py-12 text-sm text-muted-foreground">正在加载...</div>}>{element}</Suspense>;
}

export const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: "/", element: withSuspense(<HomePage />) },
      { path: "/grades/:grade", element: withSuspense(<HomePage />) },
      { path: "/members/:slug", element: withSuspense(<MemberDetailPage />) },
    ],
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: withSuspense(<AdminDashboard />) },
      { path: "members", element: withSuspense(<AdminMembersPage />) },
      { path: "members/new", element: withSuspense(<MemberEditorPage />) },
      { path: "members/:id", element: withSuspense(<MemberEditorPage />) },
    ],
  },
]);
